import { Component, OnInit } from '@angular/core';
import { GridApi } from 'ag-grid-community';
import { Router, ActivatedRoute } from '@angular/router';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { LookupsModalEditComponent } from './lookups-modal-edit/lookups-modal-edit.component';
import { LookupsAddMultipleComponent } from './lookups-add-multiple/lookups-add-multiple.component';
import { LookupsSortOrderComponent } from './lookups-sort-order/lookups-sort-order.component';
import { UntypedFormGroup, UntypedFormControl, NgModel } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-lookups',
  templateUrl: './lookups.component.html',
  styleUrls: ['./lookups.component.scss']
})
export class LookupsComponent implements OnInit {

  gridApi: GridApi;
  columnDefs;
  operations;
  rowData;
  advanceSearch;
  selectedRow;
  orgForm: UntypedFormGroup;
  modules: any;
  modules1: any[] = [];
  collapesedOrNot: boolean;
  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private summaryService: AdministrationSummaryService,
    private modalService: NgbModal
  ) {

  }

  ngOnInit() {
    this.orgForm = new UntypedFormGroup({
      NAME: new UntypedFormControl(""),
      MODULEID: new UntypedFormControl("")
    });


    this.columnDefs = [
      {
        "headerName": "Name",
        "field": "NAME",
      },
      {
        "headerName": "Program",
        "field": "MODULENAME",
      }
    ];
    this.advanceSearch = {
      "fields": [
        {
          "label": "Name",
          "field": "Name",
          "type": "text"
        }
      ]
    };
    this.operations = [
      {
        "name": "Edit",
        "id": "edit"
      }
    ];

    this.operations = this.operations.map(operation => {
      return operation && operation.id === 'add' ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });
    this.getModules();
  }

  getModules() {
    
    this.summaryService.getModuleList('api/common/getmoduleslist').subscribe((result) => {
      this.modules = result;

      var count = this.modules.length;
      var module = "";
      for (var i = 0; i < count; i++) {
        module = module + this.modules[i].value + ",";
      }
      if (count > 0)
        module = module.substring(0, module.length - 1);

      this.orgForm = new UntypedFormGroup({
        NAME: new UntypedFormControl(""),
        MODULEID: new UntypedFormControl(module)
      })
      this.setSearchSummary(this.orgForm.value);
      this.modules = [{
        label: "All",
        value: ""
      }].concat(this.modules);
    });
   
  }
 
  setSummary() {
    this.summaryService.getLookupsSummary().subscribe(summary => {
      this.rowData = summary;
    });
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked(event) {
  if(!this.modalService.hasOpenModals())
   {
    const ModelRef= this.modalService.open(LookupsModalEditComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    ModelRef.componentInstance.Content={
      heading: 'Edit',
      content: {
        id: this.selectedRow['ID'], Name: this.selectedRow['NAME'], Description: this.selectedRow['DESCRIPTION'],
        Module: this.selectedRow['MODULENAME'],Modulecode:this.selectedRow['MODULEID'], IsAllowNew: this.selectedRow["EXTENDABLE"], RecordState: this.selectedRow["RECORD_STATE"]
      }
    }
   }
  
  }

  edit() {
    const ModelRef = this['self'].modalService.open(LookupsModalEditComponent, {
      backdrop: false,
      keyboard: false,
      // ignoreBackdropClick: true,
      windowClass: 'modal-lg',
      animation: true
    });
    ModelRef.componentInstance.Content={
        heading: 'Edit',
        content: {
          id: this['self'].selectedRow['ID'], Name: this['self'].selectedRow['NAME'], Description: this['self'].selectedRow['DESCRIPTION'], Module: this['self'].selectedRow['MODULENAME'], IsAllowNew: this['self'].selectedRow["EXTENDABLE"]
        }
      }
  
  ModelRef.content.action.then(result => {
      this['self'].setSummary();
    })
  }

  add() {
    this['self'].modalService.show(LookupsAddMultipleComponent, {
      backdrop: false,
      keyboard: false,
      ignoreBackdropClick: true,
      class: 'modal-lg modal-full-height modal-right',
      animated: true
    });
  }

  sort_order() {
    this['self'].modalService.show(LookupsSortOrderComponent, {
      backdrop: false,
      keyboard: false,
      ignoreBackdropClick: true,
      class: 'modal-lg modal-full-height modal-right',
      animated: true,
      data: {
        heading: 'View',
        content: {
          id: this['self'].selectedRow['ID']
        }
      }
    });
  }

  setSearch() {
    this.SearchClear();
    var count = this.modules.length;
    var module = "";
    for (var i = 0; i < count; i++) {
      module = module + this.modules[i].value + ",";
    }
    if (count > 0)
      module = module.substring(0, module.length - 1);

    this.orgForm = new UntypedFormGroup({
      NAME: new UntypedFormControl(""),
      MODULEID: new UntypedFormControl(module)
    })

    this.summaryService.getLookupsAdvSearch(this.orgForm.value).subscribe(summary => {
      this.rowData = summary;
    });
  }

  setSearchSummary(formData) {
    this.summaryService.getLookupsAdvSearch(formData).subscribe(summary => {
      this.rowData = summary;
    });
  }


  //// Advace search Functions
  SearchClear() {
    this.orgForm.reset();
    var count = this.modules.length;
    var module = "";
    for (var i = 0; i < count; i++) {
      module = module + this.modules[i].value + ",";
    }
    if (count > 0)
      module = module.substring(0, module.length - 1);

    this.orgForm = new UntypedFormGroup({
      NAME: new UntypedFormControl(""),
      MODULEID: new UntypedFormControl(module)
    })

    //this.setSummary();
  }

  AdvanceSearch() {
    this.setSearchSummary(this.orgForm.value);
  }
}
